import wait from './Wait';
export default wait;
